<template>
  <div class="data-center">
    <div class="data-center-top">
      <div class="top-title">
        <span class="title-text">校系数据中心</span>
      </div>
    </div>
    <div class="data-center-conter">
      <div class="data-center-conter-left">
        <el-empty v-if="menuList.length == 0" description="暂无数据"></el-empty>
        <!-- 数据中心左边菜单 -->
        <!-- <div v-if="menuList.length > 0">
          <div class="l-menu" v-for="item in menuList" :key="item.id">
            <div
              :class="{ 'l-active': item.id == menuID }"
              @click="tabActive(item)"
            >
              {{ item.menuName }}
            </div>
          </div>
        </div> -->
          <el-menu
        class="el-menu-vertical-demo"
        :default-openeds="defaultOpeneds"
        @open="handleOpen"
        @close="handleClose">
      <el-submenu  :index="(index+'')" v-for="(item,index) in menuList" :key="item.id">
        <template slot="title">
          <span>{{item.menuName}}</span>
        </template>
        <el-menu-item-group @click.native="menuNameClick(index,items)"  v-for="(items,index) in item.listChild" :key="items.id">
           <el-menu-item :index="'1-' + index" :key="index">{{items.menuName}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
        <!-- <PersonalL /> -->
      </div>
       <div class="data-center-conter-right">
        <div class="conter-right-top">
          <span class="top-label">{{ topTitle }}</span>
        </div>
        <el-empty class="conter-right-box" v-if="linkRoute===''"></el-empty>
        <div v-else class="conter-right-box">
         <iframe :src="linkRoute"></iframe>
      <!-- <div class="data-center-conter-right">
        <div class="conter-right-top">
          <span class="top-label">{{ topLabel }}</span>
        </div>
        <div class="conter-right-box">
          <div class="content-item" v-for="item in contentList" :key="item.id" @click="openLink(item)">
            <el-image :src="item.iconUrl" fit="fill" class="icon">
              <div slot="error" class="image-slot">
                <img :src="require('@/assets/error/defult-head.png')" />
              </div>
            </el-image>
            <span class="text-control item-text" :title="item.menuName">{{item.menuName}}</span>
          </div>
          <el-empty v-if="!contentList.length" description="暂无数据"></el-empty>
        </div>
      </div> -->
       </div>
    </div>
    </div>
  </div>
</template>

<script>
import dataCenterApi from '@/api/loginPage/dataCenter.js'
export default {
  components: {  },
  data() {
    return {
      menuList: [],
      PutAway: "收起",
      threeMenuId: '',
      menuID: '',
      topLabel: "",
      iframeUrl: '',
      contentList: [],
       iframeUrl: '',
      linkRoute:'',
      topTitle: "",
      defaultOpeneds: ['0'] // 默认展开第一个子菜单
    };
  },
  created() {
    
    this.getMenuList() 
  },
  methods: {
      menuNameClick(index,value){
      this.linkRoute=value.route
      this.topTitle=value.menuName
       console.log(index,value,'value');
       console.log( this.linkRoute,' this.linkRoute');
    },
     handleOpen(key, keyPath) {
        // 如果已经是展开状态，不再处理
      if (this.defaultOpeneds[0] === key) return;
      // 更新defaultOpeneds以展开第一个子菜单
      this.defaultOpeneds = [key];
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
    getMenuList() {
      const parmas = {
        type: 3
      }
      dataCenterApi.queryMenuList(parmas).then(res => {
        this.menuList = res.data.data
        this.contentList = this.menuList[0].listChild || []
        this.menuID = this.menuList[0].id
        this.topLabel = this.menuList[0].menuName
      })
    },
    tabActive(item) {
      this.menuID = item.id;
      this.contentList = item.listChild || []
      this.topLabel = item.menuName
    },
    openLink(item) {
      if(!item.route) {
        this.$message.error('跳转地址不存在，请联系管理员')
        return
      }
      // this.$router.push({path: '/data-center-link', query: {link: item.route, name: item.menuName, retrunUrl: '/school-data-center'}})
      const routeUrl = this.$router.resolve({path: '/blank-iframe', query: {link: item.route}})
      window.open(routeUrl.href)
    },
  },
};
</script>

<style lang='less' scoped>
.el-menu{
 border-right: none !important;
}
/* 自定义选中菜单项的背景颜色 */
/deep/.el-menu-item.is-active {
  background-color: #F1F3F7 !important; /* 你想要的颜色 */
}
 
/* 自定义选中菜单项的文本颜色 */
/deep/.el-menu-item.is-active {
  color: #043170 !important; /* 文本颜色 */
}
.data-center {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-top: -220px;
  .data-center-top {
    float: left;
    width: 100%;
    .top-title {
      display: flex;
      justify-content: start;
      align-items: center;
      width: 100%;
      height: 140px;
      line-height: 140px;
      span {
        display: inline-block;
        height: 42px;
        line-height: 42px;
        margin-left: 11px;
        font-size: 30px;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
  .data-center-conter {
    width: 100%;
    height: calc(100vh - 240px);
    // overflow-x: auto;
    position: relative;
    top: 0;
    overflow: hidden;
    // 数据中心容器左边布局
    &-left {
      width: 17%;
      height: 100%;
      float: left;
      background-color: white;
      box-shadow: 0 0 20px 0 rgba(77, 77, 77, 0.2);
      border-radius: 8px;
      overflow-y: auto;
      transition: all 0.3s;
      padding: 0px 15px;
      // 数据中心容器左边菜单
      .l-menu {
        width: 100%;
        // height: 40px;
        line-height: 40px;
        margin: 5px auto;
        background: #F6F8FB;
        border-radius: 6px;
        text-align: center;
        color: #696969;
        cursor: pointer;
        &:first-child {
          margin-top: 30px;
        }
        & > div:first-child {
          font-size: 14px;
          font-weight: 600;
          border-radius: 6px;
        }
        & > ul {
          width: 100%;
          height: 0;
          transition: all 0.3s ease;
          will-change: height;
          overflow: hidden;
          background: #F6F8FB;
          .list {
            width: 80%;
            margin: 0 auto;
            // float: left;
            cursor: pointer;
            font-size: 12px;
            position: relative;
            color: #7895cb;
            font-weight: 500;
            &:hover {
              color: #2557b2;
            }

            & > span {
              display: block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }

          // 三级菜单选择
          .list-active {
            color: #2557b2;
            font-weight: bold;
          }
        }
      }
      .l-active {
        color: #2557b2;
        background: #e4eaf7;
        font-weight: bold;
      }
    }
    &-right {
      width: 80%;
      height: 100%;
      float: right;
      background-color: white;
      box-shadow: 0 0 20px 0 rgba(77, 77, 77, 0.2);
      border-radius: 8px;
      transition: width 0.3s;
      overflow: hidden;
      .conter-right-top {
        height: 50px;
        line-height: 50px;
        background: #F1F3F7;
        border-radius: 8px;
        padding: 0 20px;
        .top-label {
          color: #043170;
          font-size: 18px;
          font-weight: 550;
        }
      }
      .conter-right-box {
        height: calc(100% - 50px);
        padding: 20px;
        overflow-x: hidden;
        display: flex;
        flex-wrap: wrap;
          iframe{
        width: 100%;
        height: 100%;
        border: none;
          }
        .content-item {
          width: calc(93% / 8);
          margin-right: 1%;
          height: 80px;
          box-shadow: 0 0 20px 0 rgba(77, 77, 77, 0.2);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          padding: 6px 16px;
          border-radius: 8px;
          cursor: pointer;
          // 图标
          .icon {
            width: 40px;
            height: 40px;
            border-radius: 100%;
          }
          .item-text {
            width: 100%;
            text-align: center;
          }
        }
        .content-item:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>